/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ExportCode(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ExportCode',
      'aria-hidden': true,
      focusable: false,
      width:  22 * scale,
      height: 16 * scale,
      viewBox: '0 0 22 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M4.873 8.065 9.18 1.042H5.31L1 8.065 5.308 15H9.18zM16.69 1.042h-3.872l4.308 7.023L12.816 15h3.874L21 8.065z"}))
}
